<template>
    <div v-loading="Loading" element-loading-text="资源较大，拼命加载中..."  style="height: 100%;overflow: hidden;">
        <vue-office-docx v-if="['docx'].includes(type.toLowerCase())" :src="url" style="max-height: 100%;"
            @rendered="renderedHandler" />
        <vue-office-excel v-else-if="['xlsx'].includes(type.toLowerCase())" :src="url" style="max-height: 100%;"
            @rendered="renderedHandler" @error="errorHandler" />
        <vue-office-pdf v-else-if="['pdf'].includes(type)" :src="url" style="max-height: 100%;" @rendered="renderedHandler"
            @error="errorHandler" />
        <div class="d-flex flex-column flex-align-center"
            v-else-if="['png', 'jpg', 'jpeg'].includes(type.toLowerCase())">
            <img style="max-width: 100%;max-height: 700px;" :src="url" alt="">
        </div>
        <div class="d-flex flex-column flex-align-center VideoPlayer"
            v-else-if="['mp4', 'avi', 'wmv', 'mpeg', 'flv', 'rm'].includes(type.toLowerCase())">
            <video ref="videoPlayer" class="video-js" style="max-width: 100%; max-height: 700px">
                抱歉，您的浏览器不支持
            </video>
        </div>
    </div>
</template>

<script>
//引入VueOfficeDocx组件
import VueOfficeDocx from '@vue-office/docx'
//引入相关样式
import '@vue-office/docx/lib/index.css'
//引入VueOfficeExcel组件
import VueOfficeExcel from '@vue-office/excel'
//引入相关样式
import '@vue-office/excel/lib/index.css'
import VueOfficePdf from '@vue-office/pdf'
import { Loading } from 'element-ui'
import url from 'postcss-url'
import Video from 'video.js';
import 'video.js/dist/video-js.css';
export default {
    components: {
        VueOfficeDocx,
        VueOfficeExcel,
        VueOfficePdf,
    },
    props: {
        type: String,
        url: String
    },
    watch: {
        url (newVal, oldVal) {
            console.log(this.url);
            this.Loading = true;

            this.isLoading()
        }
    },
    mounted () {

        this.isLoading()
    },
    beforeDestroy () {
        if (this.videoData.player) {
            this.videoData.player.dispose();
        }
    },
    data () {
        return {
            Loading: true,
            videoData: {
                player: null,
                option: {
                    controls: true,
                    preload: 'auto',
                    sources: []
                }
            },
        }
        // docx: 'http://static.shanhuxueyuan.com/test6.docx' //设置文档网络地址，可以是相对地址
    },
    methods: {
        isLoading () {
            if (this.videoData.player) {
                this.videoData.player.pause();
            }
            if (['mp4', 'avi', 'wmv', 'mpeg', 'flv', 'rm'].includes(this.type.toLowerCase())) {
                const mp4Url = this.url;
                const srcList = [{ src: mp4Url, type: 'video/mp4' }]
                if (this.videoData.player) {
                    this.videoData.player.src(srcList);
                } else {
                    this.videoData.option.sources = srcList;
                    setTimeout(() => {
                        this.videoData.player = Video(this.$refs.videoPlayer, this.videoData.option, function () {
                        });
                        if (this.videoData.player) {
                            this.videoData.player.play();
                        }
                    });
                }
                this.Loading = false;
            }
            if (['png', 'jpg', 'jpeg'].includes(this.type.toLowerCase())) {
                this.Loading = false;
            }
        },
        renderedHandler () {
            console.log(`渲染成功`);
            this.Loading = false;
        },
        errorHandler () {
            console.log(`渲染失败`);
            this.$message.error("渲染失败，请检查文件格式是否正确")
        }
    }
}
</script>
<style lang="scss" scoped>
.VideoPlayer {
    position: relative;
    width: 80%;
    height: 700px;
    margin: 0 auto;

    .video-js {
        width: 100%;
        height: 100%;
        background: #faf6fa;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/reviewOffice.vue